import ViewersAlsoView from "./ViewersAlsoView";

export { default as useViewersAlsoView } from "./use_viewers_also_view";
export default ViewersAlsoView;
